<template>
  <div>
    <TopNavbar title="基友秀"></TopNavbar>
    <div class="home-container">
      <list v-model="isLoading"
            :finished="dataLoadingFinished"
            finished-text=" "
            @load="initItemFeed"
      >
        <MixItemListTwoCol :dataList="dataList"></MixItemListTwoCol>
      </list>
    </div>
    <div>
      <EmptyBox v-if="dataLoadingFinished && (!dataList || dataList.length === 0)" desc="空的呢"></EmptyBox>
    </div>
  </div>
</template>

<script>
  import {List, Toast} from "vant"
  import MixItemListTwoCol from "../ugc_item/MixItemListTwoCol";
  import TopNavbar from "../common/TopNavbar";
  import EmptyBox from "../common/EmptyBox";

  export default {
    name: "GoodsRemarkPage",
    components: {
      EmptyBox,
      TopNavbar, MixItemListTwoCol, List,
    },
    props: {
      showDataList: {}
    },
    data() {
      return {
        currentPage: 1,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        isLoading: false,
        dataLoadingFinished: false,

        goodsId: 0,
        listType: "goods_remark",
        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        this.goodsId = parseInt(this.$route.params.id)
        let curPage = this.$route.query.page
        if (curPage) {
          this.currentPage = parseInt(curPage)
        } else {
          this.currentPage = 1
        }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
      },

      async initItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
          ref_id: this.goodsId,
        }
        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            Toast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },
    },
    computed: {},
  };
</script>

<style scoped lang="scss">
  .home-container {
    background: white;
    padding-top: 54px;
    padding-bottom: 20px;
  }

  .pagination {
    margin: 10px 0;
    background-color: white;
  }

  .login-card-pos {
    margin-top: 45px;
  }
</style>
